var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "sticky-visible": _vm.sinisterHasDamages },
      attrs: { id: "warranty-layout" }
    },
    [
      _c(
        "ma-modal",
        { ref: "newSinisterConfirmationModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid grid--full-height grid--column grid--jc-between"
              },
              [
                _c("div", { staticClass: "mg mg--b-6" }, [
                  _c("p", { staticClass: "headline-large mg mg--b-5" }, [
                    _vm._v(
                      _vm._s(_vm.$t("warrantyLayout.modals.newSinister.title"))
                    )
                  ]),
                  _c("p", { staticClass: "text-medium" }, [
                    _vm._v(
                      _vm._s(_vm.$t("warrantyLayout.modals.newSinister.body"))
                    )
                  ])
                ]),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn secondaryBlue mg mg--r-2",
                      attrs: { "qa-confirmNewSinister-button": "" },
                      on: { click: _vm.confirmNewSinister }
                    },
                    [_vm._v(_vm._s(_vm.$t("actions.continue")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn mainBlue",
                      on: { click: _vm.cancelNewSinister }
                    },
                    [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
                  )
                ])
              ]
            )
          ])
        ],
        2
      ),
      _c("div", { staticClass: "grid grid--jc-between grid--ai-middle" }, [
        _c("p", { staticClass: "headline-large mg mg--b-3 black" }, [
          _vm._v(_vm._s(_vm.$t("warrantyLayout.registerSinister")))
        ]),
        _c(
          "button",
          {
            staticClass: "mainYellow mg mg--b-3",
            attrs: { "qa-newSinister-button": "" },
            on: { click: _vm.handleNewSinister }
          },
          [_vm._v(_vm._s(_vm.$t("warrantyLayout.newSinister")))]
        )
      ]),
      _vm.shouldShowRefs
        ? _c("ma-warranty-ref", {
            key: `${_vm.warrantyLayoutKey + 3}${_vm.$route.path}`
          })
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          !_vm.isMobilierRoute && !_vm.stateUserIsReduxMode
            ? _c("ma-warranty-props", { key: _vm.warrantyLayoutKey + 1 })
            : _vm._e()
        ],
        1
      ),
      _c("ma-tab-nav", {
        key: _vm.warrantyLayoutKey + 2,
        attrs: { items: _vm.dataUserTabs }
      }),
      _c(
        "div",
        { staticClass: "warranty__content" },
        [
          _c(
            "transition",
            { attrs: { name: "formTransition", mode: "out-in" } },
            [
              _c("router-view", {
                key: `${_vm.warrantyLayoutKey + 3}${_vm.$route.path}`
              })
            ],
            1
          )
        ],
        1
      ),
      _c("ma-warranty-sticky", { ref: "warrantyStickyAccordion" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }